import { css } from '@emotion/react'

/**
 * Resets from normalize.css v3.0.3, trimmed to elements actually
 * used in the app. Rules that duplicate browser defaults or fix
 * only legacy IE/Firefox issues are omitted.
 */
const normalizeStyles = css`
  html {
    -webkit-text-size-adjust: 100%;
  }

  aside,
  details,
  footer,
  header,
  main,
  menu,
  nav,
  section,
  summary {
    display: block;
  }

  [hidden] {
    display: none;
  }

  a {
    background-color: transparent;
  }

  a:active,
  a:hover {
    outline: 0;
  }

  abbr[title] {
    border-bottom: 1px dotted;
  }

  img {
    border: 0;
  }

  svg:not(:root) {
    overflow: hidden;
  }

  pre {
    overflow: auto;
    font-family: monospace, monospace;
    font-size: 1em;
  }

  button,
  input,
  select,
  textarea {
    color: inherit;
    font: inherit;
    margin: 0;
  }

  button {
    overflow: visible;
  }

  button,
  select {
    text-transform: none;
  }

  button,
  input[type='button'],
  input[type='reset'],
  input[type='submit'] {
    -webkit-appearance: button;
    cursor: pointer;
  }

  button[disabled],
  input[disabled] {
    cursor: default;
  }

  button::-moz-focus-inner,
  input::-moz-focus-inner {
    border: 0;
    padding: 0;
  }

  input {
    line-height: normal;
  }

  input[type='checkbox'],
  input[type='radio'] {
    box-sizing: border-box;
    padding: 0;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    height: auto;
  }

  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  textarea {
    overflow: auto;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  td,
  th {
    padding: 0;
  }
`

export default normalizeStyles
